import React from 'react'

import { Spin } from 'antd'
import styled from 'styled-components'

const Wrapper = styled.div`
  width: 98vw;
  height: 98vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
`

const PageLoader = ({ children }) => {
  return (
    <Wrapper>
      <Spin tip="Loading...">{children}</Spin>
    </Wrapper>
  )
}

export default PageLoader

// for component data loader
export const Loader = ({ children, loading = false, className }) => {
  if (loading) {
    return (
      <div className={`${className}`}>
        <Spin tip="Loading...">{children}</Spin>
      </div>
    )
  }
  return <>{children}</>
}
